import styled from "styled-components";

export const FestivalMainBannerWrapper = styled.div`
  width: 100%;
  position: relative;
  height: 360px;
`;

export const FestivalMainBannerHeader = styled.div<{ inset: null | number }>`
  position: absolute;
  z-index: 10;
  top: ${(p) => (p.inset ? p.inset + 16 : 16)}px;
  right: 27px;
  background: #12121280;
  height: 18px;
  border-radius: 50px;
  padding: 0 7px;
  gap: 10px;
  color: #ffffff;
  font-weight: 600;
  font-size: 10px;
  line-height: 18px;
  text-align: center;
`;

export const FestivalMainBannerSlideWrapper = styled.div<{
  isSelected: boolean;
  fade: boolean;
}>`
  width: 100%;
  position: absolute;
  height: 360px;
  opacity: ${(p) => (p.isSelected && !p.fade ? 1 : 0)};
  transition: all 0.3s ease-in-out;

  > img {
    width: 100%;
    height: 360px;
    object-fit: cover;
  }

  > .back {
    width: 100%;
    height: 360px;
    position: absolute;
    top: 0;
    z-index: 0;
    background: linear-gradient(
      180deg,
      rgba(18, 18, 18, 0) 51.08%,
      #121212 85.49%
    );
  }
`;

export const FestivalMainBannerTextWrapper = styled.div<{
  isTime: boolean;
}>`
  position: absolute;
  bottom: ${(p) => (p.isTime ? 25 : 65)}px;
  width: 100%;
  color: #fff;
  display: flex;
  flex-direction: column;
  gap: 2px;
  align-items: center;
  justify-content: center;
  z-index: 1;

  > .sub-title {
    font-family: esamanru;
    font-weight: 700;
    font-size: 30px;
    text-align: center;
    background: linear-gradient(
      90.64deg,
      #ffffff 0.08%,
      #825af5 31.59%,
      #baa2ff 66.11%,
      #ffffff 104.12%
    );
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  > .title {
    font-weight: 500;
    font-size: 18px;
    text-align: center;
    color: #fff;
  }
`;

export const FestivalMainBannerTime = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 40px;
  margin-top: 8px;
`;

export const FestivalMainBannerTimeItem = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;

  > .time {
    font-weight: 700;
    font-size: 32px;
    text-align: center;
    min-width: 43px;
  }

  > .unit {
    font-weight: 400;
    font-size: 16px;
    text-align: center;
    color: #d9d9d9;
    flex-shrink: 0;
  }
`;

export const FestivalMainBannerButton = styled.div`
  position: absolute;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  bottom: -44px;
  z-index: 100;

  > .button {
    background: linear-gradient(90deg, #6436e7 0%, #885eff 50%, #381e81 100%);
    box-shadow: 0px 4px 4px 0px #00000040;
    font-weight: 700;
    font-size: 17px;
    text-align: center;
    color: #ffffff;
    width: calc(100% - 32px);
    height: 57px;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export const FestivalBannerTournamentWrapper = styled.div`
  background: linear-gradient(90deg, #6436e7 0%, #885eff 50%, #381e81 100%);
  width: calc(100% - 32px);
  height: 97px;
  border-radius: 8px;
  box-shadow: 0px 4px 4px 0px #00000040;
  display: flex;
  padding: 12px 8px;
  gap: 6px;
`;

export const FestivalBannerTournamentInfoWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  gap: 8px;
`;

export const FestivalBannerTournamentInfoTop = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  color: #fff;

  > .level {
    font-weight: 600;
    font-size: 20px;
  }

  > .player {
    margin-right: 12px;
    font-weight: 300;
    font-size: 10px;

    > span {
      font-weight: 600;
    }
  }
`;

export const FestivalBannerTournamentBlindWrapper = styled.div`
  display: flex;
  width: 100%;
  gap: 5px;
`;

export const FestivalBannerTournamentBlind = styled.div<{
  isNext: boolean;
}>`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  height: 41px;
  border-radius: 8px;
  padding: 7.5px 6px;
  color: #000;
  background: ${(p) => (p.isNext ? "#D9D9D9" : "#fff")};

  > .name {
    font-weight: 500;
    font-size: 8px;
  }
  > .value {
    font-weight: 600;
    font-size: 12px;
  }
`;
